/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InternationalNameUsability {
    ALL = 'all',
    ONLY_USED = 'onlyUsed',
    NOT_USED = 'notUsed',
}
